<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card-field title="Тип">
          <i class="fas fa-circle small"
             :title="data.is_active ? 'Активен' : 'Неактивен'"
             :class="data.is_active ? 'text-success' : 'text-danger'"></i>
          {{ data.type }}
        </card-field>

        <card-field :modelValue="data.link" title="Ссылка"/>
      </div>
    </div>

    <div class="mt-3">

      <div class="float-right">
        <button-remove @click="remove" v-if="can('module.messenger.delete')"/>
      </div>


      <button-edit @click="$router.push({name: 'messenger.edit', params: {id: data.id}})"
                   v-if="can('module.messenger.update')"/>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {}
  },
  props: {
    data: Object
  },
  mounted() {
  },
  methods: {

    remove() {
      $.alertConfirm({
        type: 'red',
      }, {
        ok: () => {
          axiosGetValue('/api/admin/messenger/delete', {id: this.data.id}, () => {
            toastSuccess('Удаление завершено');
            this.$router.push({name: 'messenger.list'})
          })
        }
      });
    },
  },
}
</script>